import { FormInstance, message } from 'antd';
import { cloneDeep } from 'lodash';
import { observable, runInAction } from 'mobx';
import { Session } from 'pages/khaosat/models';
import { CommonModel } from 'services/Main/common_services';
import { ISurveyServices, SurveyAPIModel, SurveyDetailsModel, SurveyReportModel, TableReportHeader } from 'services/Survey/survey_services';
import { DataResponse } from 'services/response';
import { surveyStore } from 'stores/root_store';

export type SurveyStore = {
  data: Record<string, FormInstance<any>> | undefined;
  sessions?: Session[];
  // danh sách mẫu khảo sát
  listSurveys: DataResponse<Array<SurveyAPIModel>>;
  // detail survey
  surveyDetail: SurveyDetailsModel | undefined;
  // data báo cáo khảo sát
  dataSurveyReport: DataResponse<SurveyReportModel[]>

};

export interface ISurveyPresenter {
  createStore(): SurveyStore;
  setData(data: Record<string, FormInstance>): Promise<void>;
  resetSessions(): Promise<void>;
  setSessions(data: object): Promise<void>;

  // Danh sách mẫu khảo sát
  getListSurvey(store: SurveyStore, data: object): Promise<void>;
  //Tạo mẫu khảo sát
  createSurvey(data: object): Promise<DataResponse<null>>;
  // Edit tạo mẫu khảo sát
  editSurvey(data: object): Promise<DataResponse<null>>;
  // chi tiết mẫu khảo sát
  getSurveyById(store: SurveyStore, params: { id?: string; taskId?: string }): Promise<DataResponse<null>>;
  //lưu câu trả lời form khảo sát
  saveDataAnswer(data: object): Promise<DataResponse<null>>;
  // table survey report header
  getTabaleReportHeader(surveyId: string): Promise<DataResponse<TableReportHeader[]>>
  // lấy data báo cáo khảo sát , đánh giá
  getDataSurveyReport(store: SurveyStore, data: object): Promise<void>
  // list common survey
  getListCommonSurvey(key?: string, createTimeFrom?: string, createTimeTo?: string): Promise<CommonModel[]>
  // Xuất Excel báo cáo
  exportExcelSurvey(data: object): Promise<void>

  // xóa câu hỏi trong 1 khảo sát cụ thể
  deleteQuestionInSurvey(questionId: string): Promise<DataResponse<boolean>>

  // check xóa phần có chưa câu hỏi trong 1 khảo sát cụ thể
  deleteSessionInQuesSurvey(Id: string): Promise<DataResponse<boolean>>
}

export function createSurveyPresenter({ surveyServices }: { surveyServices: ISurveyServices }): ISurveyPresenter {
  return {
    createStore: (): SurveyStore =>
      observable({
        data: undefined,
        sessions: [],
        // danh sách mẫu khảo sát
        listSurveys: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0,
          },
        },
        // detail survey
        surveyDetail: undefined,
        // data báo cáo khảo sát
        dataSurveyReport: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0,
          },
        },
      }),
    setSessions: async (data) => {
      try {
        runInAction(() => {
          const clonedSessions = cloneDeep(surveyStore.sessions);
          clonedSessions?.push(data);
          surveyStore.sessions = clonedSessions;
        });
      } catch (error) {
        console.log(error);
      }
    },
    resetSessions: async () => {
      try {
        runInAction(() => {
          surveyStore.sessions = [];
        });
      } catch (error) {
        console.log(error);
      }
    },
    setData: async (data) => {
      try {
        runInAction(() => {
          surveyStore.data = Object.assign(surveyStore.data ?? {}, data);
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Danh sách mẫu khảo sát
    getListSurvey: async (store, data) => {
      try {
        const result = await surveyServices.getListSurvey(data);
        runInAction(() => {
          store.listSurveys.data = result.data;
          store.listSurveys.isSuccess = result.isSuccess;
          store.listSurveys.message = result.message;
          store.listSurveys.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Tạo mẫu khảo sát
    createSurvey: async (data) => {
      try {
        const result = await surveyServices.createSurvey(data);
        return result;
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: null,
        };
      }
    },
    // Edit mẫu khảo sát
    editSurvey: async (data) => {
      try {
        const result = await surveyServices.editSurvey(data);
        return result;
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: null,
        };
      }
    },
    // chi tiết mẫu khảo sát
    getSurveyById: async (store, params) => {
      try {
        const result = await surveyServices.getSurveyById(params);
        runInAction(() => {
          if (result.isSuccess) {
            store.surveyDetail = result.data;
          } else {
            store.surveyDetail = undefined;
          }

        });
        return {
          isSuccess: result.isSuccess,
          message: result.message,
          data: null,
        }
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: null,
        }
      }
    },
    //lưu câu trả lời form khảo sát
    saveDataAnswer: async (data) => {
      try {
        const result = await surveyServices.saveDataAnswer(data);
        return result;
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: null,
        };
      }
    },
    // table survey report header
    getTabaleReportHeader: async (surveyId) => {
      try {
        const result = await surveyServices.getTabaleReportHeader(surveyId);
        return result;
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: [],
        };
      }
    },
    // lấy data báo cáo khảo sát , đánh giá
    getDataSurveyReport: async (store, data) => {
      try {
        const result = await surveyServices.getDataSurveyReport(data);
        runInAction(() => {
          store.dataSurveyReport.data = result.data;
          store.dataSurveyReport.isSuccess = result.isSuccess;
          store.dataSurveyReport.message = result.message;
          store.dataSurveyReport.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // list common survey
    getListCommonSurvey: async (key, createTimeFrom, createTimeTo) => {
      try {
        const result = await surveyServices.getListCommonSurvey(key, createTimeFrom, createTimeTo);
        return result.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    // Xuất Excel báo cáo
    exportExcelSurvey: async (data) => {
      try {
        await surveyServices.exportExcelSurvey(data)
      } catch (error) {
        console.log(error);
      }
    },

    // table survey report header
    deleteQuestionInSurvey: async (questionId) => {
      try {
        const result = await surveyServices.deleteQuestionInSurvey(questionId);
        return result;
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: false,
        };
      }
    },
    // check xóa phần có chưa câu hỏi trong 1 khảo sát cụ thể
    deleteSessionInQuesSurvey: async (Id) => {
      try {
        const result = await surveyServices.deleteSessionInQuesSurvey(Id);
        return result;
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: false,
        };
      }
    },
  };
}
